import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA, trackWebVitals } from './utils/googleAnalytics';

// Initialize Google Analytics
initGA();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
    <SpeedInsights />
  </React.StrictMode>
);

// Track Web Vitals to both Google Analytics and default reporting
reportWebVitals((metric) => {
  // Send to Google Analytics
  trackWebVitals(metric);

  // Optional: Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log('Web Vital:', metric);
  }
});
